import { ComponentInstall } from "../../utils";
import Slider from "./src";

export default ComponentInstall(Slider);
